module.exports = __webpack_public_path__ + "static/media/step4-preview-bg.87f4c0fa.jpg";